import axios from "axios";
import {
  getClientInformation,
  prepareSurveyPayload,
  getUrl,
  getSnowplowInfo,
  getSnowplowCookie,
  getQuantumMetricsReplayUrl,
} from "./util";

const snowplowCookie = getSnowplowCookie(null);
const snowPlowInfo = getSnowplowInfo(null);

/***
 * Wrapper that makes a POST request to generate Balto token
 *
 * @return {String}
 */
const getBaltoToken = async () => {
  let baltoToken = "";

  try {
    const {
      data: { token },
    } = await axios({
      method: "POST",
      auth: {
        username: KONG_API_USERNAME,
        password: KONG_API_PASSWORD,
      },
      url: `${KONG_API_URL}/api/getBaltoToken`,
      data: {
        data: window.btoa(
          unescape(
            encodeURIComponent(
              JSON.stringify({
                username: BALTO_USER,
                password: BALTO_PASSWORD,
              })
            )
          )
        ),
      },
    });

    baltoToken = token;
  } catch (e) {
    console.error(e);
  }
  return baltoToken;
};

/***
 * Wrapper that makes a POST request with the survey data
 *
 * @param {String} surveyTitle
 * @param {Object} payload - the payload to send
 */
export const postSurvey = async (
  surveyTitle,
  payload,
  isPIIRedactionEnabled = true,
  screenContent = null
) => {
  try {
    let baltoToken = await getBaltoToken();

    if (!baltoToken) return;

    await axios({
      method: "POST",
      auth: {
        username: KONG_API_USERNAME,
        password: KONG_API_PASSWORD,
      },
      url: `${KONG_API_URL}/api/postSurvey`,
      data: {
        //convert the payload into base64
        data: window.btoa(
          unescape(
            encodeURIComponent(
              JSON.stringify({
                quantumMetricsReplayUrl: getQuantumMetricsReplayUrl(),
                snowplowCookie: snowplowCookie,
                snowPlowInfo: snowPlowInfo,
                duid: snowPlowInfo ? snowPlowInfo.duid : "",
                sid: snowPlowInfo ? snowPlowInfo.sid : "",
                clientInformation: getClientInformation(),
                ctx: {
                  url: getUrl(window.location),
                  title: document.title,
                },
                surveyData: prepareSurveyPayload(
                  surveyTitle,
                  payload,
                  isPIIRedactionEnabled
                ),
                screenContent,
                eventData: {
                  component: "survey",
                  type: "submit",
                },
              })
            )
          )
        ),
        balto__token: baltoToken,
      },
    });
  } catch (e) {
    console.error(e);
  }
};

/***
 * Wrapper that makes a POST request with the event data
 *
 * @param {Object} payload - the payload to send
 */
export const postEvent = async (payload) => {
  try {
    let baltoToken = await getBaltoToken();

    if (!baltoToken) return;

    await axios({
      method: "POST",
      auth: {
        username: KONG_API_USERNAME,
        password: KONG_API_PASSWORD,
      },
      url: `${KONG_API_URL}/api/postEvent`,
      data: {
        //convert the payload into base64
        data: window.btoa(
          unescape(
            encodeURIComponent(
              JSON.stringify({
                quantumMetricsReplayUrl: payload.eventQmReplayUrlOn
                  ? getQuantumMetricsReplayUrl()
                  : "",
                duid: snowPlowInfo ? snowPlowInfo.duid : "",
                sid: snowPlowInfo ? snowPlowInfo.sid : "",
                clientInformation: getClientInformation(),
                ctx: {
                  url: getUrl(window.location),
                  title: document.title,
                },
                eventData: payload,
              })
            )
          )
        ),
        balto__token: baltoToken,
      },
    });
  } catch (e) {
    console.error(e);
  }
};
